import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/links/bg_links.png";

const linkData = [
    {
        url: "https://www.instagram.com/herzdoktor_und_kollegium/",
        img: "icon_instagram_50px.jpg",
        text: "Folgen Sie uns auch auf Instagram",
    },
    {
        url: "http://www.atcardio.at",
        img: "logo_oekg.jpg",
        text: "www.atcardio.at",
    },
    {
        url: "http://www.escardio.org",
        img: "logo_escardio.jpg",
        text: "www.escardio.org",
    },
    {
        url: "http://www.acc.org",
        img: "logo_acc.jpg",
        text: "www.acc.org",
    },
    {
        url: "http://www.herzschutz.at",
        img: "logo_herzschutz.jpg",
        text: "www.herzschutz.at",
    },
    {
        url: "http://www.neurologie-funk.at",
        img: "logo_dr_funk.jpg",
        text: "www.neurologie-funk.at",
    },
    {
        url: "http://www.boei.or.at",
        img: "logo_bvi.jpg",
        text: "www.boei.or.at",
    },
    {
        url: "http://www.oedg.org",
        img: "logo_oedg.jpg",
        text: "www.oedg.org",
    },
    {
        url: "https://www.gesund-wachsen.wien/",
        img: "Logo_gesund_wachsen.jpg",
        text: "www.gesund-wachsen.wien/",
    },
    {
        url: "http://www.confraternitaet.at",
        img: "logo_conf.jpg",
        text: "www.confraternitaet.at",
    },
    {
        url: "http://www.aekwien.at",
        img: "logo_akw.jpg",
        text: "www.aekwien.at",
    },
    {
        url: "http://www.taucherarzt.at",
        img: "logo_taucherarzt.jpg",
        text: "www.taucherarzt.at",
    },
    {
        url: "http://www.pandagunda.com/",
        img: "Logo_pandagunda.jpg",
        text: "www.pandagunda.com/",
    },
    {
        url: "http://www.augen-foit.com/",
        img: "Logo_Dr_Voit.jpg",
        text: "www.augen-foit.com/",
    },
    {
        url: "https://www.endoskopie-drscharf.at/",
        img: "dr-scharf-gastroskopie-wien.jpg",
        text: "www.endoskopie-drscharf.at",
    },
    {
        url: "https://www.medfit.at",
        img: "Logo_MF.jpg",
        text: "https://www.medfit.at",
    },
    {
        url: "https://azj.at/",
        img: "Logo_AZJ.jpg",
        text: "https://azj.at",
    },
    {
        url: "https://www.drkasparek.com",
        img: "logo_kasparek.jpg",
        text: "https://www.drkasparek.com",
    },
];

const LinksList = () => {
    return (
        <div className="content">
            <table width="100%">
                <tbody>
                    {linkData.map((item, index) => (
                        <tr key={index}>
                            <td width="180" align="right">
                                <a href={item.url} target="_blank" rel="noopener noreferrer">
                                    <img src={require(`../../images/links/logos/${item.img}`)} alt={item.text} />
                                </a>
                            </td>
                            <td>&nbsp;&nbsp;</td>
                            <td>
                                <a href={item.url} target="_blank" rel="noopener noreferrer">
                                    {item.text}
                                </a>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};


const Links = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Term </h1>
                    <LinksList />
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default Links;
